/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/09/30 11:19
 * @update 2026/09/30 11:19
 */

import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { Col, DatePicker, Dropdown, Row, Typography, Button, Checkbox, NumberInput } from 'diginet-core-ui/components';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/user-actions";
import * as W14F1420Actions from "../../../actions/w14/w14F1420/w14F1420-actions";
import * as W19F2000Actions from "../../../actions/w19/w19F2000/w19F2000-actions";
import * as W14F1425Actions from "../../../actions/w14/w14f1425/w14f1425-actions";
import Config from "../../../config";
import GridContainer from "../../common/grid-container/grid-container";
import ActionToolbar from "../../common/tool-bar/action-toolbar";
import { makeStyles, useTheme } from "diginet-core-ui/theme";
import ButtonExport from "../../common/button/button-export";
const { colors } = useTheme();

const useStyles = makeStyles({
    text: {
        marginLeft: "0 !important"
    },
    moneyInputColumn: {
        width: '100%',
        margin: 0,
        '& input': {
            textAlign: 'right'
        }
    },
});

const FormID = 'W14F1425';

const W14F1425 = (props) => {
    const classes = useStyles();
    const isMobile = window.innerWidth < 576;
    const [iPermission, setIPermission] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [cboDropDownLoading, setCboDropDownLoading] = useState({});
    const [cboDropDownPeriodLoading, setCboDropDownPeriodLoading] = useState({});
    const [cboDropDownStatusLoading, setCboDropwDownStatusLoading] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [dataFilter, setDataFilter] = useState({
        IsDate: 1,
        DateFrom: Config.convertDate(new Date(), "", "MM/DD/YYYY"),
        DateTo: Config.convertDate(new Date(), "", "MM/DD/YYYY"),
        IsPeriod: 0,
        PeriodFrom: "",
        PeriodTo: "",
        ObjectTypeID: "",
        ObjectID: "",
        StatusID: "",
        SOTypeID: "",
        StatusPaymentID: "",
        StatusSOID: "",
    });
    const [dataGrid, setDataGrid] = useState([]);
    const [dataCboDropDown, setCboDropDown] = useState({});
    const [dataCboDropDownPeriod, setCboDropDownPeriod] = useState({});
    const [dataCboStatusDropDown, setCboStatusDropDown] = useState({});
    const [dataCboAddcol, setCboAddcol] = useState({});
    const [error, setError] = useState({});
    const [search, setSearch] = useState("");

    const gridContainer = useRef([]);
    const exportRef = useRef(null);

    const isLargeScreen = window.innerWidth >= 1536;

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadAddCol();
        loadForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (iPer) => {
            setIPermission(iPer)
        });
    };

    const onOpenFilter = (status) => {
        setOpenFilter(status);
    };

    const loadForm = (searchText) => {
        const params = getParamGeneral('loadForm', { StrSearch: searchText });
        setFormLoading(true);
        props.W14F1425Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataGrid(data || []);
            }
        });
    };

    const getDataType = (type) => {
        const value = type?.toLowerCase() || "";
        if (value.includes("date")) return "date";
        if (value.includes("int") || value.includes("decimal") || value.includes("numeric")) return "number";
        if (value.includes("bit")) return "boolean";
        return "string";
    };

    const getDecimalPlace = (type) => {
        const match = type?.match(/(?:decimal|numeric)\(\d+,\s*(\d+)\)/i);
        return match ? Number(match[1]) : 0;
    };

    const renderColDataType = (dataType, decimal) => {
        let colProps = {};
        if (dataType === "number" && decimal > 0) {
            colProps = {
                dataType: 'number',
                alignment: 'right',
                width: 200,
                cellRender: (e) => <NumberInput
                    readOnly
                    nonStyle
                    disabledNegative
                    decimalDigit={decimal}
                    thousandSeparator={','}
                    value={e?.value}
                    className={classes.moneyInputColumn}
                />
            };

        } else if (dataType === "date") {
            colProps = {
                alignment: 'center',
                dataType: 'date',
                format: 'dd/MM/yyyy'
            };
        }
        else if (dataType === "number") {
            colProps = {
                alignment: 'right',
                dataType: 'number',
            };
        }
        return colProps;
    }
    const loadAddCol = (searchText) => {
        const params = getParamGeneral('Addcol', { StrSearch: searchText });
        setFormLoading(true);
        props.W14F1425Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const arrCol = [];
                const arrColCal = [];
                for (let i = 0; i < data.length; i++) {
                    const col = {
                        caption: data[i]?.Caption,
                        dataField: data[i]?.FieldName,
                        dataType: getDataType(data[i]?.Datatype),
                        isSumfooter: data[i]?.IsSumfooter,
                        decimalPlace: getDecimalPlace(data[i]?.Datatype),
                    };
                    const dataTypeCell = renderColDataType(col.dataType, col.decimalPlace);
                    arrCol.push(<Column
                        key={col.dataField}
                        dataField={col.dataField}
                        caption={col.caption}
                        dataType={col.dataType}
                        {...dataTypeCell}
                    />)
                    if (col.isSumfooter === 1) arrColCal.push(<TotalItem
                        key={col.dataField}
                        column={col.dataField}
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, col.decimalPlace)}
                    />)
                }
                setCboAddcol({
                    arrCol, arrColCal
                });
            }
        });
    };

    const loadCboDropDown = (dataType, dataValue = {}) => {
        const params = getParamGeneral(dataType, dataValue);
        setCboDropDownLoading(prev => ({ ...prev, [dataType]: true }));
        props.W14F1420Actions.loadCmbDD(params, (error, data) => {
            setCboDropDownLoading(prev => ({ ...prev, [dataType]: false }));
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setCboDropDown(prev => ({
                    ...prev,
                    [dataType]: data || []
                }));
            }
        });
    };


    const loadDropDowmPeriod = (dataType) => {
        const params = getParamGeneral(dataType);
        setCboDropDownPeriodLoading(prev => ({ ...prev, [dataType]: true }));
        props.W14F1420Actions.loadDropDowmPeriod(params, (error, data) => {
            setCboDropDownPeriodLoading(prev => ({ ...prev, [dataType]: false }));
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setCboDropDownPeriod(prev => ({
                    ...prev,
                    [dataType]: data || []
                }));
            }
        });
    };

    const loadCboStatusDropdown = (dataType = '') => {
        const params = {
            UserID: Config.profile.UserID || "",
            Language: Config.language || "84",
            DivisionID: "",
            StrSearch: "",
            skip: 0,
            limit: 1,
            CompanyID: "",
            VoucherNum: "",
            GroupSalesID: "",
            SalesPersonID: "",
            CustomerID: "",
            DateFrom: null,
            DateTo: null,
            IsDetail: 0,
            DataType: dataType,
        };
        setCboDropwDownStatusLoading(prev => ({ ...prev, [dataType]: true }));
        props.W19F2000Actions.loadCbow19F2000(params, (error, data) => {
            setCboDropwDownStatusLoading(prev => ({ ...prev, [dataType]: false }));
            if (error) {
                const message = error?.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            } else if (data) {
                setCboStatusDropDown(prev => ({
                    ...prev,
                    [dataType]: data || []
                }));
            }
        }
        )
    }

    const dataSourceDropDown = (dataType) => {
        return dataCboDropDown[dataType] || [];
    };

    const dataSourceDropDownPeriod = (dataType) => {
        return dataCboDropDownPeriod[dataType] || [];
    };

    const dataSourceDropDownStatus = (dataType) => {
        return dataCboStatusDropDown[dataType] || [];
    };

    const onOpenLoaded = () => {
        loadCboDropDown('CmbObType');
        loadCboDropDown('CmbObID');
        loadCboDropDown('StatusID');
        loadCboDropDown('SOType');
        loadDropDowmPeriod('CmbPeriodF');
        loadDropDowmPeriod('CmbPeriodT');
        loadCboStatusDropdown('LoadStatusSO');
        loadCboStatusDropdown('LoadStatusPayment');
    };

    const getParamGeneral = (type, data = {}) => {
        const { IsDate, DateFrom = null, DateTo = null, IsPeriod, PeriodFrom = null, PeriodTo = null,
            ObjectTypeID = "", ObjectID = "", StatusID = "", StatusSOID = "", SOTypeID = "", StatusPaymentID = "", } = dataFilter;
        let params = {
            DataType: type,
            IsDate,
            DateFrom,
            DateTo,
            IsPeriod,
            PeriodFrom,
            PeriodTo,
            ObjectTypeID: data?.ObjectTypeID ?? ObjectTypeID,
            ObjectID,
            StatusID,
            StatusSOID,
            SOTypeID,
            StatusPaymentID,
            StrSearch: data?.StrSearch || "",
        };
        return params;
    };

    const btnCRM = [
        {
            buttonName: Config.lang("Xuat_du_lieu"),
            buttonType: 'button',
            icon: 'Sheet',
            color: 'Success',
            align: 'right',
            disabled: false,
            onClick: () => {
                if (exportRef.current.getWrappedInstance().onClick) {
                    exportRef.current.getWrappedInstance().onClick("0")
                }
            }
        }];

    const onSearch = (text = '', isSearchFilter = false) => {
        if (isSearchFilter) {
            loadAddCol();
            loadForm();
        } else {
            setSearch(text);
            loadAddCol(text);
            loadForm(text);
        }
    };

    const onChangeFilter = (keyName, e) => {
        if (!e || !keyName) return;
        let value;
        if (['IsDate', 'IsPeriod'].includes(keyName)) {
            const checked = e?.target?.checked ?? e?.checked ?? e?.value ?? e;
            value = checked ? 1 : 0;
        } else value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo'].includes(keyName)) value = null;
        let objPlus = {
            ...dataFilter,
            [keyName]: value,
        };
        switch (keyName) {
            case "IsDate":
                if (value === 1) {
                    objPlus.IsPeriod = 0;
                } else {
                    objPlus.IsPeriod = 1;
                }
                break;
            case "IsPeriod":
                if (value === 1) {
                    objPlus.IsDate = 0;
                } else {
                    objPlus.IsDate = 1;
                }
                break;
            case "ObjectTypeID":
                loadCboDropDown('CmbObID', {ObjectTypeID: value});
                break;
            default:
                break;
        }
        setDataFilter(objPlus);
        if (!Config.isEmpty(value) && error?.[keyName]) setError({ ...error, [keyName]: '' });
    };

    const renderDateFilter = () => { // Ngay 
        return (
            <Row>
                <Col xs={12} sm={3} className={'pdl0'} verticalAlign={"center"} >
                    <Checkbox
                        className="mgl4x"
                        label={Config.lang('Ngay')}
                        labelProps={{ type: "h4", color: colors.text.label, whiteSpace: 'nowrap' }}
                        checked={Number(dataFilter?.IsDate) === 1}
                        onChange={(e) => onChangeFilter("IsDate", e)}
                    />
                </Col>
                <Col xs={12} sm={4}>
                    <DatePicker
                        clearAble
                        viewType={'outlined'}
                        displayFormat={"DD/MM/YYYY"}
                        disabled={dataFilter?.IsDate !== 1}
                        placeholder={Config.lang('Tu')}
                        max={dataFilter?.DateTo}
                        value={dataFilter?.DateFrom}
                        onChange={e => onChangeFilter('DateFrom', e)}
                    />
                </Col>
                {!isMobile &&
                    <Col xs={12} sm={1} className={"pdl0 display_row valign-middle align-center"}>
                        <Typography type='p1' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>-</Typography>
                    </Col>
                }
                <Col xs={12} sm={4} className={!isMobile ? 'pdl0' : ""}>
                    <DatePicker
                        clearAble
                        viewType={'outlined'}
                        displayFormat={"DD/MM/YYYY"}
                        disabled={dataFilter?.IsDate !== 1}
                        placeholder={Config.lang('Den')}
                        min={dataFilter?.DateFrom}
                        value={dataFilter?.DateTo}
                        onChange={e => onChangeFilter('DateTo', e)}
                    />
                </Col>
            </Row>
        )
    }
    const renderObjectType = () => { // Nhóm đối tượng
        return (
            <Row className={"display_row align-center"}>
                <Col xs={12} sm={3}>
                    <Typography type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Nhom_doi_tuong")}</Typography>
                </Col>
                <Col xs={12} sm={9}>
                    <Dropdown
                        style={{ backgroundColor: "white" }}
                        viewType={'outlined'}
                        valueExpr={'ObjectTypeID'}
                        displayExpr={'ObjectTypeName'}
                        loading={!!cboDropDownLoading['CmbObType']}
                        dataSource={dataSourceDropDown('CmbObType')}
                        value={dataFilter?.ObjectTypeID}
                        onChange={e => onChangeFilter('ObjectTypeID', e)}
                    />
                </Col>
            </Row>
        )
    }
    const renderStatusSO = () => { // Trạng thái đơn
        return (
            <Row className={"display_row align-center"}>
                <Col xs={12} sm={3}>
                    <Typography type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Trang_thai_don")}</Typography>
                </Col>
                <Col xs={12} sm={9}>
                    <Dropdown
                        style={{ backgroundColor: "white" }}
                        viewType={'outlined'}
                        valueExpr={'StatusSOID'}
                        displayExpr={'StatusSOName'}
                        loading={!!cboDropDownStatusLoading['LoadStatusSO']}
                        dataSource={dataSourceDropDownStatus('LoadStatusSO')}
                        value={dataFilter?.StatusSOID}
                        onChange={e => onChangeFilter('StatusSOID', e)}
                    />
                </Col>
            </Row>
        )
    }
    const renderIsPeriod = () => { //Kỳ
        return (
            <Row>
                <Col xs={12} sm={3} className={'pdl0'} verticalAlign={"center"} >
                    <Checkbox
                        className="mgl4x"
                        label={Config.lang('Ky')}
                        labelProps={{ type: "h4", color: colors.text.label }}
                        checked={Number(dataFilter?.IsPeriod) === 1}
                        onChange={(e) => onChangeFilter("IsPeriod", e)}
                    />
                </Col>
                <Col xs={12} sm={4}>
                    <Dropdown
                        style={{ backgroundColor: "white" }}
                        viewType={'outlined'}
                        valueExpr={'PeriodFrom'}
                        displayExpr={'PeriodName'}
                        loading={!!cboDropDownPeriodLoading['CmbPeriodF']}
                        disabled={dataFilter?.IsPeriod !== 1}
                        dataSource={dataSourceDropDownPeriod('CmbPeriodF')}
                        placeholder={Config.lang('Tu')}
                        value={dataFilter?.PeriodFrom}
                        className={'full_w'}
                        onChange={e => onChangeFilter('PeriodFrom', e)}
                    />
                </Col>
                {!isMobile &&
                    <Col xs={12} sm={1} className={"pdl0 display_row valign-middle align-center"}>
                        <Typography type='p1' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>-</Typography>
                    </Col>
                }
                <Col xs={12} sm={4} className={!isMobile ? 'pdl0' : ""}>
                    <Dropdown
                        style={{ backgroundColor: "white" }}
                        viewType={'outlined'}
                        valueExpr={'PeriodTo'}
                        displayExpr={'PeriodName'}
                        loading={!!cboDropDownPeriodLoading['CmbPeriodT']}
                        disabled={dataFilter?.IsPeriod !== 1}
                        dataSource={dataSourceDropDownPeriod('CmbPeriodT')}
                        placeholder={Config.lang('Den')}
                        value={dataFilter?.PeriodTo}
                        onChange={e => onChangeFilter('PeriodTo', e)}
                    />
                </Col>
            </Row>
        )
    }
    const renderStatus = () => { //Trạng thái thanh toán hàng hóa
        return (
            <Row className={"display_row align-center"}>
                <Col xs={12} sm={3}>
                    <Typography type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Trang_thai_TTHH")}</Typography>
                </Col>
                <Col xs={12} sm={9}>
                    <Dropdown
                        style={{ backgroundColor: "white" }}
                        viewType={'outlined'}
                        valueExpr={'StatusID'}
                        displayExpr={'StatusName'}
                        loading={!!cboDropDownLoading['StatusID']}
                        dataSource={dataSourceDropDown('StatusID')}
                        value={dataFilter?.StatusID}
                        onChange={e => onChangeFilter('StatusID', e)}
                    />
                </Col>
            </Row>

        )
    };
    const renderObject = () => { //Đối tượng
        return (
            <Row className={"display_row align-center"}>
                <Col xs={12} sm={3}>
                    <Typography type='h4' lineClamp={1} color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Doi_tuong")}</Typography>
                </Col>
                <Col xs={12} sm={9}>
                    <Dropdown
                        style={{ backgroundColor: "white" }}
                        viewType={'outlined'}
                        valueExpr={'ObjectID'}
                        displayExpr={'ObjectName'}
                        loading={!!cboDropDownLoading['CmbObI']}
                        dataSource={dataSourceDropDown('CmbObID')}
                        value={dataFilter?.ObjectID}
                        onChange={e => onChangeFilter('ObjectID', e)}
                    />
                </Col>
            </Row>
        )
    }
    const renderStatusPayment = () => { //Trạng thái thanh toán đơn
        return (
            <Row className={"display_row align-center"}>
                <Col xs={12} sm={3}>
                    <Typography type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Trang_thai_TT_don")}</Typography>
                </Col>
                <Col xs={12} sm={9}>
                    <Dropdown
                        style={{ backgroundColor: "white" }}
                        viewType={'outlined'}
                        valueExpr={'StatusPaymentID'}
                        displayExpr={'StatusPaymentName'}
                        loading={!!cboDropDownStatusLoading['StatusPaymentID']}
                        dataSource={dataSourceDropDownStatus('LoadStatusPayment')}
                        value={dataFilter?.StatusPaymentID}
                        onChange={e => onChangeFilter('StatusPaymentID', e)}
                    />
                </Col>
            </Row>
        )
    }
    const renderSOType = () => { //Loại đơn hàng
        return (
            <Row className={"display_row align-center"}>
                <Col xs={12} sm={3}>
                    <Typography type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Loai_don_hang")}</Typography>
                </Col>
                <Col xs={12} sm={9}>
                    <Dropdown
                        style={{ backgroundColor: "white" }}
                        viewType={'outlined'}
                        valueExpr={'SOTypeID'}
                        displayExpr={'SOTypeName'}
                        loading={!!cboDropDownLoading['SOType']}
                        dataSource={dataSourceDropDown('SOType')}
                        value={dataFilter?.SOTypeID}
                        onChange={e => onChangeFilter('SOTypeID', e)}
                    />
                </Col>
            </Row>
        )
    }

    const filterRenderLarge = () => {
        return <Row>
            <Col xl={4}>{renderDateFilter()}</Col>
            <Col xl={3.5}>{renderObjectType()}</Col>
            <Col xl={3.5}>{renderStatusSO()}</Col>
            <Col xl={4}>{renderIsPeriod()}</Col>
            <Col xl={3.5}>{renderObject()}</Col>
            <Col xl={3.5}>{renderStatusPayment()}</Col>
            <Col xl={4}> </Col>
            <Col xl={3.5}>{renderStatus()}</Col>
            <Col xl={3.5}>{renderSOType()}</Col>
            <Col xl={1} className={'display_row valign-bottom'} verticalAlign={'end'}>
                <Button
                    style={{ backgroundColor: "white" }}
                    startIcon={"Search"}
                    viewType={"outlined"}
                    label={Config.lang("Tim_kiem")}
                    onClick={() => onSearch("", true)}
                />
            </Col>
        </Row>
    };

    const filterRender = () => {
        return <Row>
            <Col xs={12} sm={12} md={5} lg={5}>{renderDateFilter()}</Col>
            <Col xs={12} sm={12} md={5} lg={5}>{renderStatus()}</Col>
            <Col xs={12} sm={12} md={5} lg={5}>{renderIsPeriod()}</Col>
            <Col xs={12} sm={12} md={5} lg={5}>{renderStatusPayment()}</Col>
            <Col xs={12} sm={12} md={5} lg={5}>{renderObjectType()}</Col>
            <Col xs={12} sm={12} md={5} lg={5}>{renderStatusSO()}</Col>
            <Col xs={12} sm={12} md={5} lg={5}>{renderObject()}</Col>
            <Col xs={12} sm={12} md={5} lg={5}>{renderSOType()}</Col>
            <Col xs={12} sm={12} md={2} lg={2} className={'display_row valign-bottom'} verticalAlign={'end'}>
                <Button
                    style={{ backgroundColor: "white" }}
                    startIcon={"Search"}
                    viewType={"outlined"}
                    label={Config.lang("Tim_kiem")}
                    onClick={() => onSearch("", true)}
                />
            </Col>
        </Row>
    };

    const renderGrid = useMemo(() => {
        return (
            <GridContainer
                reference={(ref) => gridContainer.current = ref}
                dataSource={dataGrid}
                isPer={iPermission}
                buttonCRM={btnCRM}
                loading={formLoading}
                typePaging={'normal'}
                keyExpr={'OrderNo'}
                pagerFullScreen
                itemPerPage={80}
                listPerPage={[80, 160, 240, 320]}
                onOpenFilter={onOpenFilter}
                elementAttr={{ style: `height: ${openFilter ? Config.getHeightGrid() - 330 : Config.getHeightGrid() - 86}px; max-height: ${openFilter ? '' : '830px'}` }}
                filterRender={isLargeScreen ? filterRenderLarge() : filterRender()}
                valueSearch={search}
                onSearch={onSearch}
                onOpenLoaded={onOpenLoaded}
            >
                {dataCboAddcol?.arrCol && dataCboAddcol.arrCol}
                <Summary>
                    {dataCboAddcol?.arrColCal && dataCboAddcol.arrColCal}
                </Summary>
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, formLoading, cboDropDownLoading, dataCboAddcol, dataSourceDropDown, dataFilter, dataSourceDropDownStatus,
        dataSourceDropDownPeriod, cboDropDownStatusLoading, cboDropDownPeriodLoading, isLargeScreen, openFilter]);

    const paramExport = [
        { id: "UserID", type: "Varchar", value: Config.profile.UserID },
        { id: "Language", type: "Varchar", value: Config.language || '84' },
        { id: "DivisionID", type: "VarChar", value: Config.profile.DivisionID || "" },
        { id: "IsDate", type: "TINYINT", value: dataFilter?.IsDate },
        { id: "DateFrom", type: "DATETIME", value: dataFilter?.DateFrom },
        { id: "DateTo", type: "DATETIME", value: dataFilter?.DateTo },
        { id: "IsPeriod", type: "TINYINT", value: dataFilter?.IsPeriod },
        { id: "PeriodFrom", type: "DATETIME", value: dataFilter?.PeriodFrom },
        { id: "PeriodTo", type: "DATETIME", value: dataFilter?.PeriodTo },
        { id: "ObjectTypeID", type: "VarChar", value: dataFilter?.ObjectTypeID },
        { id: "ObjectID", type: "VarChar", value: dataFilter?.ObjectID },
        { id: "StatusID", type: "VarChar", value: dataFilter?.StatusID },
        { id: "SOTypeID", type: "VarChar", value: dataFilter?.SOTypeID },
        { id: "StatusSOID", type: "VarChar", value: dataFilter?.StatusSOID },
        { id: "StatusPaymentID", type: "VarChar", value: dataFilter?.StatusPaymentID },
        { id: "StrSearch", type: "VarChar", value: search },
    ];

    if (!iPermission) return null;

    return (
        <div className={'page-container-new'} style={{ height: openFilter ? '100vh' : '' }}>
            <ButtonExport
                className={"hide"}
                ref={ref => exportRef.current = ref}
                reportTypeID={"W14F1425"}
                id={'slave1'}
                name={Config.lang('In1')}
                onlyShowPopup
                param={paramExport}
            />
            <ActionToolbar title={Config.lang("Theo_doi_thong_tin_giao_dich_hoa_hong")} />
            {renderGrid}
        </div>
    );
}

export default connect(null, (dispatch) => ({
    W14F1420Actions: bindActionCreators(W14F1420Actions, dispatch),
    W19F2000Actions: bindActionCreators(W19F2000Actions, dispatch),
    W14F1425Actions: bindActionCreators(W14F1425Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W14F1425);